/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AdminFeeCollectionGetFeeCollectionsParams,
  AdminOrganizationFeeCollectionDTOQueryResultDTO,
  FilterModelDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const adminFeeCollectionGetFeeCollections = (
    organizationId: number,
    semesterId: number,
    filterModelDTO: FilterModelDTO[],
    params?: AdminFeeCollectionGetFeeCollectionsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AdminOrganizationFeeCollectionDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/AdminFeeCollection/list/${semesterId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getAdminFeeCollectionGetFeeCollectionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeeCollectionGetFeeCollections>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFeeCollectionGetFeeCollectionsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof adminFeeCollectionGetFeeCollections>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFeeCollectionGetFeeCollectionsParams}, TContext> => {
    
const mutationKey = ['adminFeeCollectionGetFeeCollections'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminFeeCollectionGetFeeCollections>>, {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFeeCollectionGetFeeCollectionsParams}> = (props) => {
          const {organizationId,semesterId,data,params} = props ?? {};

          return  adminFeeCollectionGetFeeCollections(organizationId,semesterId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminFeeCollectionGetFeeCollectionsMutationResult = NonNullable<Awaited<ReturnType<typeof adminFeeCollectionGetFeeCollections>>>
    export type AdminFeeCollectionGetFeeCollectionsMutationBody = FilterModelDTO[]
    export type AdminFeeCollectionGetFeeCollectionsMutationError = ErrorType<unknown>

    export const useAdminFeeCollectionGetFeeCollections = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminFeeCollectionGetFeeCollections>>, TError,{organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFeeCollectionGetFeeCollectionsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminFeeCollectionGetFeeCollections>>,
        TError,
        {organizationId: number;semesterId: number;data: FilterModelDTO[];params?: AdminFeeCollectionGetFeeCollectionsParams},
        TContext
      > => {

      const mutationOptions = getAdminFeeCollectionGetFeeCollectionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    